import React, { ReactNode } from 'react';
import { IS_MOCK_AUTH_MODE } from '../auth/mock';
import StubAllAuthProvider from './StubAllAuthProvider';

// Login, profile selection and token renewal are handled by RequireLogin and
// src/auth/ — this provider only owns the mock-mode branch. In production
// builds IS_MOCK_AUTH_MODE is constant-folded to `false`, so the
// `<StubAllAuthProvider>` branch and its import get tree-shaken out.
const AllAuthProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  if (IS_MOCK_AUTH_MODE) {
    return <StubAllAuthProvider>{children}</StubAllAuthProvider>;
  }

  return <>{children}</>;
};

export default AllAuthProvider;
